import React, { Component } from 'react';
import FAQService from '../../../../src/services/faq.service';
import FAQArticle from '../../../../src/models/FAQArticle';
import FAQSearchResult from '../../../../src/models/FAQSearchResult';
import FAQArticleView from '../../../../src/views/components/FAQArticleView';
import SearchBar from '../../../../../views/components/SearchBar.Component';

declare var dataLayer: any;

type FAQSearchPageProps = {
    service: FAQService,
    numberOfSearchResults: number,
    labels: any,
    language: string,
    persona: string,
}

type FAQSearchPageState = {
    searched: boolean,
    keywords: string,
    result: FAQSearchResult
}

export default class FAQSearchPage extends Component<FAQSearchPageProps, FAQSearchPageState> {
    constructor(props: FAQSearchPageProps) {
        super(props);
        this.state = {
            searched: false,
            keywords: "",
            result: new FAQSearchResult()
        };
    }

    public async search(keyword: string) {
        if (keyword.length > 0) {
            const result: FAQSearchResult = await this.props.service.searchFAQArticles(keyword, this.props.persona, this.props.language, this.props.numberOfSearchResults);
            this.setState(
                {
                    searched: true,
                    result: result,
                    keywords: keyword,
                }
            )
        } else {
            this.setState(
                {
                    searched: false
                }
            )
        }
    }

    public handleChange(event: any) {
        this.setState({
            keywords: event.target.value
        });

    }

    public render() {
        return (
            <div className="my-3">
                <div className="mb-5">
                    <SearchBar onSearch={(keyword: string) => { this.search(keyword) }} searchButtonText={this.props.labels["searchbutton"]} placeholderText={this.props.labels["searchPlaceholder"]} />
                </div>
                <div className="mt-3">
                    {
                        this.state.searched ?
                            <React.Fragment>
                                <span className="mb-3 font-weight-bold">{this.props.labels['searchResultTitle'].replace("{0}", this.state.keywords)}</span>
                                <h3 className='sr-only' aria-live='polite'>{this.state.result.results.length} results found</h3>
                                {
                                    this.state.result.numberOfTotalResults > 0 ?
                                        <div className="d-flex flex-column">
                                            {
                                                this.state.result.results.map((result: FAQArticle, index: number) => {
                                                    return <FAQArticleView article={result} key={"faqArticle_" + index} id={"faqArticle_" + index} />
                                                })
                                            }
                                        </div>
                                        : <div>{this.props.labels['no-results-message']}</div>
                                }
                            </React.Fragment>
                            : null
                    }
                </div>
            </div>
        );
    }
}